import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import IconOutput from './icons/Output';
import IconPower from './icons/Power';
import IconCharing from './icons/Charing';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';

const PowerStation: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('PowerStation');

    const items = [
        {
            title: t('item1_title'),
            desc: t('item1_desc'),
            icon: IconOutput,
        },
        {
            title: t('item2_title'),
            desc: t('item2_desc'),
            icon: IconPower,
        },

        {
            title: t('item3_title'),
            desc: t('item3_desc'),
            icon: IconCharing,
        },
    ];

    return (
        <div className={`${styles.PowerStation} GtmModuleData-section`} data-section-id="PowerStation" id="PowerStation">
            <EcoSectionCommon className="pad" title={t('title')} />
            <div className="box trail-layout">
                <div className="left">
                    <div className="title">{t('title')}</div>
                    <div className="items">
                        {items.map((item, index) => (
                            <div className="item" key={index}>
                                <div className="icon">{<item.icon />}</div>
                                <div className="content">
                                    <div className="content-title">{item.title}</div>
                                    <div className="content-desc">{item.desc}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="right">
                    <EcoImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1753683580346/pc.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1753683580557/pad.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1753683580851/h5.jpg"
                    />
                </div>
            </div>
        </div>
    );
};

export default PowerStation;
